import collect from "collect.js";
import { prefixFile } from "../fetch/fetchApi";

const paramUrl = window.location.href.split("?")[1];

class Tool {
  static getUrlParam(paramName) {
    let [paramValue, isFound] = ["", !1];
    if (!paramUrl) {
      return null;
    }
    if (paramUrl.indexOf("=") > 1) {
      const arrSource = paramUrl.split("&");
      let i = 0;
      while (i < arrSource.length && !isFound) {
        const item = arrSource[i];
        if (
          item.indexOf("=") >= 0
          && item.split("=")[0].toLowerCase() === paramName.toLowerCase()
        ) {
          paramValue = decodeURIComponent(item.split("=")[1]);
          isFound = !0;
        }
        i++;
      }
    }
    if (!paramValue) {
      paramValue = null;
    }
    return paramValue;
  }

  // 对接口返回的值类型的字符串，比如‘1’，‘0’或者返回的数值类型0，1，1334等进行格式化，并过滤空字符串，null,和undefined
  static filterNumberStr(value, valueType) {
    // valueType默认不传，则不对value进行修改，仅格式化。如果为money,则可以格式化为数值类型，并保留两位小数。如果为INT,则格式化为整形数值
    if (value && value !== "" && value !== "null" && value !== "---") {
      if (valueType === "string") {
        return value.toString();
      }
      if (valueType === "money") {
        return (+value).toFixed(2);
      } else if (valueType === "INT") {
        return parseInt(value);
      } else {
        return +value;
      }
    } else {
      if (valueType === "money") {
        return 0.0;
      } else if (valueType === "INT") {
        return 0;
      } else {
        return '---';
      }
    }
  }

  // 对接口返回的值类型的字符串，比如‘1’，‘0’或者返回的数值类型0，1，1334等进行格式化，并过滤空字符串，null,和undefined
  static filterNumberStrEx(value, valueType) {
    // valueType默认不传，则不对value进行修改，仅格式化。如果为money,则可以格式化为数值类型，并保留四位小数。如果为INT,则格式化为整形数值
    if (value && value !== "" && value !== "null" && value !== "---") {
      if (valueType === "string") {
        return value.toString();
      }
      if (valueType === "money") {
        return (+value).toFixed(4);
      } else if (valueType === "INT") {
        return parseInt(value);
      } else {
        return +value;
      }
    } else {
      if (valueType === "money") {
        return 0.0;
      } else if (valueType === "INT") {
        return 0;
      } else {
        return '---';
      }
    }
  }

  static notNull(value) {
    if (typeof value !== "object") {
      return (
        value
        && value !== ""
        && value !== "null"
        && value !== "---"
        && value !== "--"
        && value !== "[]"
      );
    } else {
      return value && value.length > 0;
    }
  }

  static pySegSort(arr, empty) {
    // 中文按首字符排序
    if (!String.prototype.localeCompare) return null;
    const letters = "*abcdefghjklmnopqrstwxyz".split("");
    const zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split("");
    const segs = [];
    let curr;
    collect(letters).each((i) => {
      curr = { letter: this, data: [] };
      collect(arr).each(() => {
        if (
          (!zh[i - 1] || zh[i - 1].localeCompare(this) <= 0)
          && `${this.localeCompare(zh[i])}` === "-1"
        ) {
          curr.data.push(this);
        }
      });
      if (empty || curr.data.length) {
        segs.push(curr);
        curr.data.sort((a, b) => {
          return a.localeCompare(b);
        });
      }
    });
    return segs;
  }

  static sortChinese(arr) {
    arr.sort((a, b) => {
      return a.label.localeCompare(b.label);
    });
    return arr;
  }

  static exportData(serviceName, fileName, param, isEncodeURI) {
    const paramJson = collect(param).toJson();
    const exportUrl = `${prefixFile}/export.do?serviceName=${serviceName}&fileName=${fileName}&searchJson=${paramJson}`;
    const alink = document.createElement("a");
    const evt = document.createEvent("MouseEvents");
    alink.href = isEncodeURI ? encodeURI(exportUrl) : exportUrl; // 根据blob 创建 url
    if (document.all) {
      alink.click();
    } else {
      evt.initEvent("click", true, true);
      alink.dispatchEvent(evt);
    }
  }

  // 可提取到tool作为工具函数，时间段格式化函数
  static formatDate(dateArrayStr) {
    const dateRange = JSON.parse(dateArrayStr) || [];
    const dateRangeStrArr = [];
    if (dateRange.length > 0) {
      for (let i = 0; i <= dateRange.length - 1; i++) {
        const time1 = (`${dateRange[i][0]}`).split("").length > 3
          ? `${(`${dateRange[i][0]}`).substr(0, 2)}:${(`${dateRange[i][0]}`).substr(2, 2)}`
          : `0${(`${dateRange[i][0]}`).substr(0, 1)}:${(`${dateRange[i][0]}`).substr(1, 2)}`;
        const flatDate1 = `${`${dateRange[i][0]}` === "0" ? "00:00" : time1}`;
        const time2 = (`${dateRange[i][1]}`).split("").length > 3
          ? `${(`${dateRange[i][1]}`).substr(0, 2)}:${(`${dateRange[i][1]}`).substr(2, 2)}`
          : `0${(`${dateRange[i][1]}`).substr(0, 1)}:${(`${dateRange[i][1]}`).substr(1, 2)}`;
        const flatDate2 = `${`${dateRange[i][1]}` === "0" ? "00:00" : time2}`;
        dateRangeStrArr.push(`${flatDate1}-${flatDate2}`);
      }
    }
    return dateRangeStrArr.join(" ; ");
  }

  static UUID = () => {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 || 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r && 0x3) || 0x8).toString(16);
    });
    return uuid;
  };

  /**
   *
   * @param {需要格式化的值} text
   * @param {保留小数位数，默认2} fixed
   * @param {需要转换的目标单位} unit
   * @param {转换规则值 例： 10000 转 1w，此值即为10000} per
   */
  static numberFormat(text, fixed = 2) {
    let result = 0;
    if (text || text === 0) {
      text = Number(text);
      result = text.toFixed(fixed);
    }

    return result;
  }

  /**
   * @param {时间字符串，只适用于没有分隔符的时间格式，如yyyyMM } text
   * @param {*类型，日期或时间} type
   */
  static translateTime(text, format = "YYYY-MM") {
    const arr = Array.from(text);
    // 正则匹配替换
    const result = format.replace(/[YMDHms]/g, () => {
      return arr.shift();
    });

    return result;
  }

  /**
   * 百分比四舍五入会导致超出100%,需要累加然后对最后一条计算，减去多出来的值
   * @param {数据源*} source
   * @param {百分比的key*} key
   * @param {要计算的index*} index
   */
  static setPercentWhileMathRound(source, key, index) {
    const list = JSON.parse(JSON.stringify(source));

    let totalPer = 0;
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      // 如果是字符串,可能存在百分比符号
      if (typeof item[key] === "string" && item[key].includes("%")) {
        item[key] = item[key].replace("%", "");
      }
      totalPer += Number(item[key]);
    }

    // 如果累加量大于100
    if (totalPer > 100) {
      const record = source[index];

      if (typeof record[key] === "string" && record[key].includes("%")) {
        record[key] = record[key].replace("%", "");
      }

      record[key] = `${(Number(record[key]) - (totalPer - 100)).toFixed(2)}%`;
    }
    return source;
  }
}

export default Tool;



// WEBPACK FOOTER //
// ./src/AntD/utils/Tool.js